export const ROOT_ID = 'js-root'

export const API_URL = '/api/knowledge-base'
export const URL_PREFIX = '/knowledge-base'
export const BLOG_URL_PREFIX = '/blog'

export const SEARCH_MIN_QUERY_LENGTH = 3
export const SEARCH_QUERY_PARAM = 'phrase'
export const VISIBLE_SEARCH_RESULTS = 5
export const SEARCH_DEBOUNCE_INTERVAL = 250
